import { Component, EventEmitter, Input, Output } from '@angular/core';

export type LovableFeedTab = 'foryou' | 'following';

@Component({
    selector: 'app-lovable-feed-header',
    templateUrl: './lovable-feed-header.component.html',
    styleUrls: ['./lovable-feed-header.component.css'],
})
export class LovableFeedHeaderComponent {
    @Input() activeTab: LovableFeedTab = 'foryou';
    @Output() activeTabChange = new EventEmitter<LovableFeedTab>();

    setTab(tab: LovableFeedTab): void {
        this.activeTabChange.emit(tab);
    }
}
